import store from "../store-root";
import api from "../../service/api";

const moduleName = "permission";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    async GetMenuPermission({ commit }, menuId) {
      let result = await api.get(`/api/permission/${menuId}`);
      return result.data;
    },
  },
});

export default moduleName;
